import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthLogoutRequestBody, AuthLogoutResponse } from "./types";

export class AuthLogoutAPI extends BaseAPI<
  AuthLogoutRequestBody,
  AuthLogoutResponse
> {
  protected route = ApiRoutes.auth.logout;
  protected method = RequestMethod.POST;
}
